import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { CaptureAcceptRequest, CaptureAcceptResult, CaptureView } from '../models/object-capture.model';
import { ExecutionJob } from './execution-job.service';

/** Offene Aufnahmen einer Objektbibliothek (NEX-1713) und ihr Start (NEX-1719). */
@Injectable({ providedIn: 'root' })
export class ObjectCaptureService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiBaseUrl}/api/v1/projects`;

  /** Alle offenen Aufnahmen der Bibliothek, aelteste zuerst; der Server filtert nicht nach Auftrag. */
  list(projectId: string, mappingId: string): Observable<CaptureView[]> {
    const params = new HttpParams().set('status', 'PENDING');
    return this.http.get<CaptureView[]>(this.capturesUrl(projectId, mappingId), { params });
  }

  /** Als Blob statt als `<img src>`: nur so geht das Token des Interceptors mit. */
  image(projectId: string, mappingId: string, captureId: string): Observable<Blob> {
    return this.http.get(`${this.capturesUrl(projectId, mappingId)}/${captureId}/image`, { responseType: 'blob' });
  }

  /** Uebernimmt angenommene Aufnahmen in die Bibliothek und verwirft die uebrigen (NEX-1714). */
  accept(projectId: string, mappingId: string, request: CaptureAcceptRequest): Observable<CaptureAcceptResult> {
    return this.http.post<CaptureAcceptResult>(`${this.capturesUrl(projectId, mappingId)}/accept`, request);
  }

  /** Startet eine Aufnahme auf genau diesem Rechner; die `id` der Antwort ist der Auftrag der Live-Seite. */
  startRecording(projectId: string, mappingId: string, runnerId: string, startUrl: string): Observable<ExecutionJob> {
    return this.http.post<ExecutionJob>(`${this.base}/${projectId}/object-mappings/${mappingId}/recordings`, {
      runnerId,
      startUrl,
    });
  }

  private capturesUrl(projectId: string, mappingId: string): string {
    return `${this.base}/${projectId}/object-mappings/${mappingId}/captures`;
  }
}
